import React, { useState } from "react";
import "./Login.scss";

import Email from "./Email";
import Document from "./Document";
import config from "~/config";
import useQuery from "~/hooks/use-query";

import api from "~/services/api";
import { getToken } from "~/services/token";
import { getAuthenticatedUrl } from "~/services/authenticatedUrl";

import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import * as MeActions from "~/store/modules/me/actions";
import ButtonSecondary from "../Button/ButtonSecondary";
import ButtonPrimary from "../Button/ButtonPrimary";

export default function Login({ companyToken }) {
  const token = getToken();
  const isAuthenticatedUrl = getAuthenticatedUrl();
  const dispatch = useDispatch();
  const history = useHistory();
  const query = useQuery();
  const [email, setEmail] = useState(false);
  const [document, setDocument] = useState(false);
  const [error, setError] = useState(null);
  const logo = useSelector((store) => store.configs.website.logo);

  function handleLoginEmail() {
    setEmail(!email);
  }

  function handleLoginDocument() {
    setDocument(!document);
  }

  function handleLoginByGuest() {
    setDocument(false)
    setEmail(true)
  }

  function handleProblemScreen(e) {
    e.preventDefault();
    history.push(`/update-system`);
  }

  function fetchMe() {
    api
      .get(`/v1/me`)
      .then(({ data: me }) => {
        dispatch(MeActions.me(me));
        const getRedirect = query.get("redirect");

        if (document) {
          history.push(getRedirect || '/')
        } else {
          history.push({
            pathname: "/my-account",
            search: getRedirect ? `?redirect=${getRedirect}` : null,
          });
        }
      })
      .catch(() => {
        setError(
          `Desculpe, não conseguimos buscar suas informações. Tente novamente!`
        );
      });
  }

  return (
    <React.Fragment>
      <div className="login-container">
        {email && (
          <div className="login">
            <Email onHide={handleLoginEmail} fetchMe={fetchMe} />
          </div>
        )}
        {(document || companyToken) && (
          <div className="login">
            <Document companyToken={companyToken} onHide={handleLoginDocument} handleLoginByGuest={handleLoginByGuest} fetchMe={fetchMe} />
          </div>
        )}
        {!email && !document && !companyToken && (
          <div className="login">
            <div className="logo">
              <img alt="" src={logo} />
            </div>

            {isAuthenticatedUrl && !token ? (
              <>
                <div className="text">
                  <h1>Obrigado!</h1>
                  <p>Você fez logoff de sua sessão com segurança!</p>

                  <div className="help">
                    Problemas no login? <a href="#" onClick={handleProblemScreen}>CLIQUE AQUI</a> e atualize o sistema.
                  </div>
                </div>
              </>
            ) : (
              <>
                <div className="text">
                  <h1>Bem vindo (a)!</h1>
                  <p>Faça seu login e acesse todos os recursos!</p>
                  {error && <span>{error}</span>}
                </div>

                <ul className="links">
                  <li>
                    <ButtonPrimary onClick={handleLoginDocument}>
                      Sou cooperado
                    </ButtonPrimary>
                  </li>
                  {config.enableGuestAccess && (
                    <li>
                      <ButtonSecondary onClick={handleLoginEmail}>
                        Não sou cooperado
                      </ButtonSecondary>
                    </li>
                  )}
                </ul>
              </>
            )}
          </div>
        )}
      </div>
    </React.Fragment>
  );
}
